<template>
  <footer class="bg-[#121212] text-white border-t-8 border-[#d20a0a]">
    <div class="max-w-screen-xl mx-auto px-4 py-8">
      <!-- Top content: logo + links + redes -->
      <div
        class="flex flex-col md:flex-row justify-between items-center md:items-start gap-8"
      >
        <!-- Logo -->
        <div class="flex items-center space-x-2">
          <img
            :src="appLogo"
            alt="CombateOne"
            class="h-8"
          />
        </div>

        <!-- Links -->
        <!-- <div
          class="flex flex-col md:flex-row gap-6 text-sm uppercase font-medium"
        >
          <a href="#" class="hover:underline">Help</a>
          <a href="#" class="hover:underline">FAQ</a>
          <a href="#" class="hover:underline">Terms of Use</a>
          <a href="#" class="hover:underline">Privacy Policy</a>
        </div> -->

        <!-- Redes sociais -->
        <div class="flex gap-4">
          <a href="#" class="text-gray-400 hover:text-white transition">
            <i class="fab fa-facebook-f text-lg"></i>
          </a>
          <a href="#" class="text-gray-400 hover:text-white transition">
            <i class="fab fa-twitter text-lg"></i>
          </a>
        </div>
      </div>

      <!-- Divider -->
      <div class="border-t border-gray-700 my-6"></div>

      <!-- Copyright -->
      <div class="text-center text-sm text-gray-500">
        A Plataforma X e designs associados são registrados e/ou de propriedade exclusiva da AD Tech Tecnologia e Inovação Ltda.
        © 2025 Todos os direitos reservados
      </div>
    </div>
  </footer>
</template>

<script setup>
import { dataShared } from '../store'
import { computed } from 'vue'

const appLogo = computed(() => dataShared.getters.getAppLogo)
const theme = computed(() => dataShared.getters.getTheme)
</script>
